import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';

class ParticipantesLimitedDatatables extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const event = this.props.participants.selectedEvent;

        if (!event)
            return;

        const events = this.props.events;
        const token = this.props.token;

        const presencaRender = function (data, type) {
            if (type === "display") {
                if (data)
                    return '<span class="bg-success" style="padding: 1px 3px;">CONFIRMADO</span>';
                else
                    return '<span class="bg-warning" style="padding: 1px 3px;">À CONFIRMAR</span>';
            } else {
                return data ? "CONFIRMADO" : "À CONFIRMAR";
            }
        };

        // IMPORTANTE: Ao mudar índice da coluna bagde, atualizar variável abaixo (zero index)
        const badgeIndex = 5;
        const datatablesColumns = [
            { data: "cpf", title: "CPF", render: $.datatable.renders.text() },
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "email", title: "Email", render: $.datatable.renders.text() },
            { data: "pacote", title: "Pacote", render: $.datatable.renders.text() },
            {
                data: function (row, type) {
                    if (type === "display") {
                        return '<button type="button" data-cpf="' + row.cpf + '" class="btn btn-primary btn-xs credenciamento" aria-label="Ir para Credenciamento">' +
                            'ir para credenciamento' +
                            '</button>'
                    }

                    return null;
                },
                searchable: false,
                orderable: false,
            },
            { data: "badge", title: "Presença", render: presencaRender, visible: false },
        ];

        const props = this.props;
        const postCreation = function () {
            $(".events-participants-limited-datatables").on('click', 'button.credenciamento', function (e) {
                e.preventDefault();
                props.events.toCredenciamento($(this).attr('data-cpf'), token);
            });
        };

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/events/' + event.id + '/participants/select',
        });

        const buttons = null;

        const order = [[1, "asc"]];
        const pageLength = 100;

        const domClassName = 'events-participants-limited-datatables';
        const title = 'Participantes de ' + event.name;
        const subTitle = 'Gerenciamento';

        const calculateTotal = function (api) {
            let totalConfirmados = 0;
            let total = 0;

            let rows = api.column(badgeIndex).data();

            if (rows) {
                rows.each(function (value) {
                    totalConfirmados = totalConfirmados + (value ? 1 : 0);
                    total++;
                });
            }

            return '<span><strong>Confirmados: ' + totalConfirmados + '/' + total + '</strong></span>';
        };

        const headerCallback = function(thead, data, start, end, display) {
            let html = calculateTotal(this.api());

            let rowConfirmados = $('.row-head-confirmados');

            if (rowConfirmados.length === 0) {
                rowConfirmados = $('<div class="row row-head-confirmados"><div class="col-sm-12" style="padding-top: 7px; padding-bottom: 7px;"></div></div>');
                let rowTable = $(thead).parents('.row').first();
                $(rowTable).before(rowConfirmados);
            }

            rowConfirmados.find('div').empty().html(html);
        };

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       order={order}
                       pageLength={pageLength}
                       buttons={buttons}
                       headerCallback={headerCallback}
                       editorCreateVisible={false}
                       editorEditVisible={false}
                       editorRemoveVisible={false}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
                       postCreation={postCreation}
            />
        );
    }
}

class ParticipantesLimited extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props;
        const app = props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.PARTICIPANTES_LIMITED)
            return null;

        const participants = props.participants;

        if (!participants.selectedEvent)
            return (
                <div>
                    <h3 className="page-header">Nenhum evento selecionado</h3>
                </div>
            );

        return (
            <div>
                <ParticipantesLimitedDatatables {...this.props} />
            </div>
        );
    }
}

export default ParticipantesLimited;


// WEBPACK FOOTER //
// src/views/pages/ParticipantesLimited.jsx